import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-8">Page not found</p>
      <Link
        to="/"
        className="bg-orange-500 text-white px-6 py-3 rounded-lg font-medium text-lg shadow-lg hover:bg-orange-600 transition-colors"
      >
        Go Home
      </Link>
    </div>
  );
};

export default NotFound;